import type { QueryClient } from "@tanstack/react-query";

let queryClient: QueryClient | null = null;

export function registerAuthQueryClient(client: QueryClient): void {
  queryClient = client;
}

export function clearAuthSessionQuery(): void {
  queryClient?.removeQueries({ queryKey: ["auth", "session"] });
}
